import { useLocation } from 'react-router-dom';
import create from 'zustand';

interface TitleStoreState {
  /** Stores the last location for which title has been set. */
  titleLastSetLocation: string;
  title: string;
  changeTitle: (title: string) => void;
}

export const useTitleStore = create<TitleStoreState>((set) => {
  return {
    titleLastSetLocation: '',
    title: '',
    changeTitle(title: string) {
      document.title = title;
      set({ titleLastSetLocation: document.location.pathname, title });
    },
  };
});

/**
 *
 * @returns The title when it is ready to be used (when a title has been set for current location.pathname).
 */
export function useTitleWhenReady(): string | null {
  const location = useLocation();
  const titleLastSetLocation = useTitleStore((state) => state.titleLastSetLocation);
  const title = useTitleStore((state) => state.title);

  return location.pathname === titleLastSetLocation ? title : null;
}
